document.addEventListener("DOMContentLoaded", function () {
  const container = document.querySelector(
    "div#shopify-block-AQ0VjK3VmK3g2V1IrR__loop_subscriptions_loop_widget_YjVLTq"
  );
  if (!container) return;
  const newDiv = document.createElement("div");
  newDiv.innerHTML = "🔥MOST POPULAR";
  newDiv.className = "subscription_promo_banner";
  container.prepend(newDiv);
});

$(document).ready(function () {
  $(document).on("click", ".cart-product-add-button", function () {
    const btn = $(this);
    var $item = btn.closest(".cart-product-item");
    var variantId = $item
      .find(".variant_selection_cart [type=radio][name=id]:checked")
      .val();
    const sellingPlanId = $item
      .find(".variant_selection_cart [type=radio][name=id]:checked")
      .data("selling-plan-id");
    const data = {
      id: variantId,
      quantity: 1,
      ...(sellingPlanId && { selling_plan: sellingPlanId }),
    };

    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: data,
      dataType: "json",
      beforeSend: function () {
        btn.find(".loading__spinner").removeClass("hidden");
      },
      success: function (response) {
        // console.log("Product added to cart:", response);
        btn.find(".loading__spinner").addClass("hidden");
        fetch(`${routes.cart_url}?section_id=cart-drawer`)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(
              responseText,
              "text/html"
            );
            const selectors = ["cart-drawer-items", ".cart-drawer__footer"];
            for (const selector of selectors) {
              const targetElement = document.querySelector(selector);
              const sourceElement = html.querySelector(selector);
              if (targetElement && sourceElement) {
                targetElement.replaceWith(sourceElement);

                const cartDrawerItems =
                  document.querySelector("cart-drawer-items");
                if (
                  cartDrawerItems &&
                  cartDrawerItems.classList.contains("is-empty")
                ) {
                  cartDrawerItems.classList.remove("is-empty");
                }

                const emptyState = document.querySelector(
                  ".drawer__inner-empty"
                );
                if (emptyState) {
                  emptyState.style.display = "none";
                }

                const drawerInner = document.querySelector(".cart__contents");
                if (drawerInner) {
                  drawerInner.style.display = "block";
                }

                const checkoutButton = document.querySelector(
                  ".cart__checkout-button"
                );
                if (checkoutButton) {
                  checkoutButton.removeAttribute("disabled");
                }
                const cartDrawer = document.querySelector("cart-drawer");
                if (cartDrawer && cartDrawer.classList.contains("is-empty")) {
                  cartDrawer.classList.remove("is-empty");
                }
              }
            }
          })
          .catch((e) => {
            console.error(e);
          });
      },
      error: function () {
        alert("Failed to add product. Please try again.");
      },
    });
  });
});
